import React from 'react';
import { useRecoilValue } from 'recoil';

import { Player, PlayerGem, PlayerContent } from '@/ui-components/Player';

import useLayout from '@/use/useLayout';
import { gamePhaseState, turnState } from '@/framework/board';

import { userPlayerState } from '@/framework/player';
import { userSelector } from '@/framework/user';

import { openUserProfile } from '@/use/useModal';

export const UserPlayer = () => {
  const { layout } = useLayout();

  const userPlayer = {
    id: useRecoilValue(userPlayerState.id),
    userId: useRecoilValue(userPlayerState.userId),
    colour: useRecoilValue(userPlayerState.colour),
    name: useRecoilValue(userPlayerState.name),
    country: useRecoilValue(userPlayerState.country),
    score: useRecoilValue(userPlayerState.score),
  };
  const equippedGem = useRecoilValue(userSelector.user).activeGem;

  const turn = useRecoilValue(turnState);
  const gamePhase = useRecoilValue(gamePhaseState);
  const playerLayout = layout === 'portrait' ? 'inline' : 'centered';

  const canClick = userPlayer.userId && userPlayer.userId !== 'anon';
  const isTurn = gamePhase === 'playing' && userPlayer.id === turn;

  const handleClick = () => {
    if (userPlayer.userId) {
      openUserProfile(userPlayer.userId);
    }
  };

  return (
    <Player
      turn={userPlayer.id === turn}
      layout={playerLayout}
      onClick={canClick ? handleClick : undefined}
    >
      <PlayerGem type={userPlayer.colour ?? equippedGem} />
      <PlayerContent
        name={userPlayer.name}
        country={userPlayer.country}
        score={userPlayer.score}
        turnMessage="Your turn"
        {...{ isTurn }}
      />
      {/* <PlayerTimer /> */}
    </Player>
  );
};
